<template>
  <div class="row w-100 max-w-xl mx-auto">
    <!-- 麥克風測試 -->
    <div class="col-6 col-lg-12 p-2">
      <div class="border h-100 d-flex flex-column justify-content-between align-items-center rounded position-relative border_main11">
        <div class="p-2 w-100 bg-blue-lighter-toeic">
          <p class="font-bold text-white text-center text-lg mb-0">麥克風測試</p>
        </div>
        <div class="item_img p-2 mb-1 d-flex justify-content-center">
          <div class="p-2 pointer" @click="toggleRecord">
            <div class="record_img">
              <canvas id="canvas" ref="recordRefTest" class="canvas canvas_test"></canvas>
            </div>
          </div>
        </div>
        <div class="p-3">
          <p class="gept_main_color text-center fw-semibold mb-0 text-base">
            請對著麥克風說話，線條產生波動，代表麥克風正常。
          </p>
        </div>
      </div>
    </div>
    <!-- 音檔播放測試 -->
    <div class="col-6 col-lg-12 p-2">
      <div class="border h-100 d-flex flex-column justify-content-between align-items-center rounded position-relative border_main11">
        <div class="p-2 w-100 bg-blue-lighter-toeic">
          <p class="font-bold text-white text-center text-lg mb-0">音檔播放測試</p>
        </div>
        <div class="item_img p-2 mb-1 pointer">
          <!-- <div> -->
            <img
              src="@/assets//image/toeic/toeic_exam/play_test.png"
              alt=""
              v-if="!isPlayingAudio"
              @click="audio_play"
              class="w-100 object-contain"
            />
            <img
              src="@/assets//image/toeic/toeic_exam/play_test_on.png"
              alt=""
              v-else
              @click="audio_stop"
              class="w-100 object-contain"
            />
          <!-- </div> -->
        </div>
        <div class="p-3">
          <p class="gept_main_color text-center fw-semibold mb-0 text-base">
            請點選播放後，確認聲音播放是否正常。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recorder from 'js-audio-recorder'

export default {
  name: 'TestingTools',

  data () {
    return {
      recorderJS: null,
      audioData: null,
      sound_effect: null,
      backgroundImg: null,

      isPlayingAudio: false,
      isRecording: false,
      drawRecordId: null
    }
  },

  mounted () {
    this.preloadBackground()
    this.setAudio()
    this.safeInitMediaDevices()
  },

  beforeDestroy () {
    this.audio_stop()
    this.stopRecord()
    cancelAnimationFrame(this.drawRecordId)
    if (this.recorderJS) {
      this.recorderJS.destroy()
      this.recorderJS = null
    }
  },

  methods: {
    async safeInitMediaDevices () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

        if (window.AudioContext) {
          const ctx = new AudioContext()
          if (ctx.state === 'suspended') await ctx.resume()
          ctx.close()
          this.toggleRecord()
        }

        console.log('[麥克風權限 OK]')
      } catch (err) {
        this.handleMicError(err)
      }
    },

    handleMicError (err) {
      const name = err?.name
      if (name === 'NotAllowedError') {
        alert('請點擊網址列左方的鎖頭圖示，並允許存取麥克風。')
      } else if (name === 'NotFoundError') {
        alert('未偵測到麥克風裝置，請確認設備已接上或使用其他設備。')
      } else if (name === 'NotReadableError') {
        alert('麥克風可能被其他應用佔用，請稍後再試。')
      } else if (name === 'SecurityError') {
        alert('請使用 HTTPS 網站開啟本功能。')
      } else {
        alert('無法啟用麥克風，請確認裝置與瀏覽器設定。')
        console.error('[錄音錯誤]', err)
      }
    },

    preloadBackground () {
      this.backgroundImg = new Image()
      this.backgroundImg.src = require('@/assets/image/toeic/toeic_exam/recording_img2.png')
    },

    // 播放測試音效
    setAudio () {
      const audioMap = {
        TOEIC_exam: '/toeic.mp3',
        default: '/Bridge.mp3'
      }
      const src = audioMap[this.$route.name] || audioMap.default
      this.sound_effect = new Audio(src)
    },

    audio_play () {
      if (!this.sound_effect) return

      if (!this.isPlayingAudio) {
        this.isPlayingAudio = true
        this.sound_effect.play()

        if (!this.sound_effect._hasEndedListener) {
          this.sound_effect.addEventListener('ended', this.audio_stop)
          this.sound_effect._hasEndedListener = true
        }
      }
    },

    audio_stop () {
      if (!this.sound_effect) return
      this.isPlayingAudio = false
      this.sound_effect.pause()
      this.sound_effect.currentTime = 0
    },

    // 錄音控制
    toggleRecord () {
      if (!this.isRecording) {
        this.startRecord()
      } else {
        this.clickStopRecord()
      }
    },

    startRecord () {
      if (this.isRecording) return

      try {
        this.recorderJS = new Recorder()
      } catch (err) {
        console.error('[Recorder 初始化失敗]', err)
        alert('錄音元件初始化失敗，請重新整理或更換瀏覽器。')
        return
      }

      this.recorderJS.start().then(() => {
        this.isRecording = true
        this.drawRecord()
      }).catch((err) => {
        console.error('[錄音啟動失敗]', err)
        alert('無法啟動錄音，請確認麥克風權限與裝置設定')
        this.recorderJS?.stop()
        this.recorderJS?.destroy()
        this.recorderJS = null
        cancelAnimationFrame(this.drawRecordId)
      })
    },

    clickStopRecord () {
      if (!this.recorderJS) return

      this.recorderJS.stop()
      this.audioData = this.recorderJS.getWAVBlob()
      this.isRecording = false

      cancelAnimationFrame(this.drawRecordId)
    },

    stopRecord () {
      if (!this.recorderJS) return
      this.recorderJS.stop()
      this.isRecording = false
    },

    playRecord () {
      if (this.recorderJS) {
        this.recorderJS.play()
      } else if (this.audioData) {
        const url = URL.createObjectURL(this.audioData)
        const audio = new Audio(url)
        audio.play()
      }
    },

    // 波形繪製
    drawRecord () {
      this.drawRecordId = requestAnimationFrame(this.drawRecord)
      if (!this.$refs.recordRefTest || !this.recorderJS) return

      const dataArray = this.recorderJS.getRecordAnalyseData()
      this.drawWave({
        canvas: this.$refs.recordRefTest,
        dataArray,
        bgcolor: 'rgba(200,200,200,0)',
        lineWidth: 2,
        lineColor: 'rgb(255,255,255)'
      })
    },

    drawWave ({ canvas, dataArray, bgcolor, lineWidth, lineColor }) {
      if (!canvas || !dataArray) return
      const ctx = canvas.getContext('2d')
      const bufferLength = dataArray.length
      const sliceWidth = canvas.width / bufferLength

      ctx.clearRect(0, 0, canvas.width, canvas.height)

      if (this.backgroundImg?.complete) {
        ctx.drawImage(this.backgroundImg, 0, 0, canvas.width, canvas.height)
      }

      ctx.lineWidth = lineWidth
      ctx.strokeStyle = lineColor
      ctx.beginPath()

      let x = 0
      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128
        const y = (v * canvas.height) / 2
        if (i === 0) ctx.moveTo(x, y)
        else ctx.lineTo(x, y)
        x += sliceWidth
      }

      ctx.lineTo(canvas.width, canvas.height / 2)
      ctx.stroke()
    }
  }
}
</script>
<style lang="scss" scoped>
.max-w-xl { max-width: 36rem; }
.item_img {
  max-width: 155px;
  max-height: 155px;
}
.record_img {
  width: 140px;
  height: 140px;
  background-image: url('~@/assets//image/toeic/toeic_exam/recording_img2.png');
  background-size: 140px;
}
.canvas_test {
  width: 100%;
  height: 100%;
  max-width: 140px;
  max-height: 140px;
}
</style>
